import { EMPTY_LIST } from '../../../constants/common'
import { USER_DOCUMENTS_ENTITY } from '../../../constants/entity'
import { FILE_SCOPE_USER } from '../../../constants/file'
import {
  getDocumentsItemActions,
  getDocumentsMassActions,
} from '../../Document'
import { toEmailRecipientSelectItem } from '../../Email'
import { EntityTabDocuments } from '../../EntityTab'
import { useUserProfileContext } from '../../User'

import {
  USER_PROFILE_TAB_DOCUMENTS_BREADCRUMB_USER,
  USER_PROFILE_TAB_DOCUMENTS_QA_NAME,
} from './UserProfileTabDocuments.constants'

function UserProfileTabDocuments({ userData, onReloadTabCounters }) {
  const { registerDocumentsTabReload } = useUserProfileContext()

  const breadcrumbRootItems = [
    {
      id: USER_PROFILE_TAB_DOCUMENTS_BREADCRUMB_USER,
      title: userData?.fullname,
    },
  ]

  const sendViaEmailProps = {
    recipients: userData?.email
      ? [toEmailRecipientSelectItem(userData)]
      : EMPTY_LIST,
  }

  return (
    <EntityTabDocuments
      breadcrumbRootItems={breadcrumbRootItems}
      breadcrumbStorageItemId={USER_PROFILE_TAB_DOCUMENTS_BREADCRUMB_USER}
      entity={USER_DOCUMENTS_ENTITY}
      getItemActions={getDocumentsItemActions}
      getMassActions={getDocumentsMassActions}
      objectId={userData?.id}
      qaNameTable={USER_PROFILE_TAB_DOCUMENTS_QA_NAME}
      rootDirectoryId={userData?.directory_id}
      scope={FILE_SCOPE_USER}
      sendViaEmailProps={sendViaEmailProps}
      onLoadCounters={onReloadTabCounters}
      onRegisterReload={registerDocumentsTabReload}
    />
  )
}

export default UserProfileTabDocuments
